var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tab-selector" },
    _vm._l(_vm.options, function(option) {
      return _c(
        "div",
        {
          staticClass: "tab-option",
          class: option.name === _vm.selectedTab ? "selected" : undefined,
          on: {
            click: function($event) {
              return _vm.handleClick(option.name)
            }
          }
        },
        [
          _c("div", { staticClass: "text" }, [
            _c("p", [_vm._v(_vm._s(option.literal))])
          ]),
          _c("div", { staticClass: "bar" })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }